import AbstractContract from "@/domains/Contracts/AbstractContract";
import ContractType from "@/domains/Contracts/ContractType";
import DateSimple from "@/core/types/DateSimple";
import Core from "@/core/Core";

/* Публичная оферта */
class ContractPublic extends AbstractContract {

    isDraft: boolean;
    isActual: boolean;

    type: ContractType;

    publicationDate: DateSimple | null;

    text: string | null;

    static fromServer(data: any, contract = new ContractPublic()): ContractPublic {
        super.fromServer(data, contract);

        contract.type = Core.utils.hydrate(data.type, ContractType.fromServer)!;
        contract.publicationDate = Core.utils.hydrate(data.publicationDate, DateSimple.fromServer);

        return contract;
    }
}

export default ContractPublic;